"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _cssInJs = require("@compiled/css-in-js");

var _react = _interopRequireWildcard(require("react"));

var _detail = require("./detail");

var _label = require("./label");

var _jsxFileName = "/home/ackwell/code/xivanalysis/tooltips/src/tooltip.tsx",
    _this = void 0;

/**
 * Naive tooltip component combining `Label`, with `Details` shown on hover. For more nuanced
 * popup handling,you'll want to implement the popup yourself using `Label` & `Details` directly.
 */
var Tooltip = /*#__PURE__*/(0, _react.memo)(function Tooltip(_ref) {
  var sheet = _ref.sheet,
      id = _ref.id;

  // Using a naive state implementation here rather than CSS-only to prevent every
  // single tooltip from requesting the full payload on mount
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      hovering = _useState2[0],
      setHovering = _useState2[1];

  return /*#__PURE__*/_react["default"].createElement(Container, {
    onMouseEnter: function onMouseEnter() {
      return setHovering(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHovering(false);
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react["default"].createElement(_label.Label, {
    sheet: sheet,
    id: id,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 4
    }
  }), hovering && /*#__PURE__*/_react["default"].createElement(Flyout, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 18
    }
  }, /*#__PURE__*/_react["default"].createElement(_detail.Detail, {
    sheet: sheet,
    id: id,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 6
    }
  })));
});
exports.Tooltip = Tooltip;

var Container = /*#__PURE__*/_react["default"].forwardRef(function (_ref2, ref) {
  var _ref2$as = _ref2.as,
      C = _ref2$as === void 0 ? "span" : _ref2$as,
      props = (0, _objectWithoutProperties2["default"])(_ref2, ["as"]);
  return /*#__PURE__*/_react["default"].createElement(_cssInJs.CC, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 89
    }
  }, /*#__PURE__*/_react["default"].createElement(_cssInJs.CS, {
    hash: "1841w8n",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 93
    }
  }, [".cc-1841w8n{position:relative}"]), /*#__PURE__*/_react["default"].createElement(C, (0, _extends2["default"])({}, props, {
    ref: ref,
    className: "cc-1841w8n" + (props.className ? " " + props.className : ""),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 153
    }
  })));
});

if (process.env.NODE_ENV === "development") {
  Container.displayName = "Container";
}

var Flyout = /*#__PURE__*/_react["default"].forwardRef(function (_ref3, ref) {
  var _ref3$as = _ref3.as,
      C = _ref3$as === void 0 ? "div" : _ref3$as,
      props = (0, _objectWithoutProperties2["default"])(_ref3, ["as"]);
  return /*#__PURE__*/_react["default"].createElement(_cssInJs.CC, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 85
    }
  }, /*#__PURE__*/_react["default"].createElement(_cssInJs.CS, {
    hash: "johov6",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 89
    }
  }, [".cc-johov6{position:absolute;top:100%;left:0}"]), /*#__PURE__*/_react["default"].createElement(C, (0, _extends2["default"])({}, props, {
    ref: ref,
    className: "cc-johov6" + (props.className ? " " + props.className : ""),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 163
    }
  })));
});

if (process.env.NODE_ENV === "development") {
  Flyout.displayName = "Flyout";
}